import { environment } from "./environment";

export const paths = {
  AUTH_REFRESH: `${environment.baseUrl}/auth/refresh`,
  AUTH_EXCHANGE_ENDPOINT: `${environment.baseUrl}/auth/generate`,
};